import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is this just an assistant service?",
      answer: "No. It's structured operational support. We handle tasks, but we also help build a cleaner way for your work to flow."
    },
    {
      question: "What does \"fractional\" actually mean?",
      answer: "You get the support you need—without hiring full-time. Think \"high impact, right-sized hours.\""
    },
    {
      question: "Do you work with confidential information?",
      answer: "Yes. We operate with discretion, boundaries, and clear access rules."
    },
    {
      question: "How fast can we start?",
      answer: "Depending on availability, onboarding can be quick once scope is agreed."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section-padding bg-white">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-olive-brown">
            Quick questions, clear answers.
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="max-w-4xl mx-auto space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden card-shadow animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 md:py-6 text-left flex items-center justify-between hover:bg-gray-100 transition-colors duration-200"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3 className="text-base sm:text-lg font-semibold text-olive-brown pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <Minus className="h-5 w-5 text-burnt-orange" />
                  ) : (
                    <Plus className="h-5 w-5 text-burnt-orange" />
                  )}
                </div>
              </button>

              <div
                id={`faq-answer-${index}`}
                className={`px-4 sm:px-6 md:px-8 transition-all duration-300 ease-in-out mt-4 ${
                  openIndex === index
                    ? 'pb-6 opacity-100 max-h-screen'
                    : 'pb-0 opacity-0 max-h-0'
                } overflow-hidden`}
              >
                <p className="text-sm sm:text-base text-olive-brown/70 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;